(function () {
  document.documentElement.classList.add('lpc-js');

  function reveal() {
    var els = document.querySelectorAll('.lpc-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal);
  else reveal();

  var chips = document.querySelectorAll('.lpc-chip');
  var tiles = document.querySelectorAll('.lpc-grid .lpc-tile');
  var empty = document.querySelector('.lpc-empty');
  if (!chips.length || !tiles.length) return;

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      chip.setAttribute('aria-pressed', 'true');
      var filter = chip.getAttribute('data-filter');
      var visible = 0;
      tiles.forEach(function (tile) {
        var match = filter === 'all' || tile.getAttribute('data-family') === filter;
        tile.hidden = !match;
        if (match) visible++;
      });
      if (empty) empty.classList.toggle('is-visible', visible === 0);
    });
  });
})();
